import React from 'react'
import { SearchResultProps } from 'semantic-ui-react'
import styled from 'styled'

export const SearchResult = ({
  location,
  title: addressLine1
}: SearchResultProps) => {
  const { city, state, zip } = location || {}

  return (
    <ResultWrapper>
      <AddressWrapper>
        <Header>{addressLine1}</Header>
        <AddressHeader>{`${city}, ${state} ${zip}`}</AddressHeader>
      </AddressWrapper>
    </ResultWrapper>
  )
}

const ResultWrapper = styled.div`
  display: flex;
`
const AddressWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const AddressHeader = styled.h6`
  color: grey;
  margin: 0;
  font-size: 1.1em;
  font-weight: 400;
`

const Header = styled.h6`
  display: flex;
  align-items: center;
  margin: 0;
  font-weight: 400;
`

export default SearchResult
